import { privileges } from '@/services/privileges'
import { Plugin } from 'vue'

export const Privileges: Plugin = {
  install(app: any) {
    app.config.globalProperties.$privileges = privileges
  }
}
